var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var dragscroll = require('../../libs/dragscroll');
var loaders = require('../../layout/components/loaders');
var alarmsTablePagination = require('../../alarms/alarmsTablePagination');
var io = require('../../libs/socketio');
var renderEventRow = require('../../events/eventRow');

var eventsComponent = {};

eventsComponent.oninit = function (vnode) {
  var ctrl = this;
  ctrl.isExpanded = prop(false);
  ctrl.eventsRids = prop([]);
  ctrl.eventsRecords = prop([]);
  ctrl.isLoading = prop(false);
  ctrl.sortAscending = prop(false);
  ctrl.pageSize = vnode.attrs.pageSize || 10;
  ctrl.socketHandler = function () {
    ctrl.loadEvents();
  };

  ctrl.loadEvents = async function () {
    ctrl.isLoading(true);
    var end = moment();
    var start = moment(end).subtract(7, 'days');
    try {
      var data = await loaders.requestWithLoader({
        url: `/api/v1/events/rids`,
        method: 'GET',
        params: {
          start: start.valueOf(),
          end: end.valueOf(),
          type: 'Incident,AlarmEvent,CommFailure,Command,AuthEvent,Comment,Override',
          sort: 'desc',
          limit: 500
        },
        background: true
      });
      var rids = Array.isArray(data) ? data.map(function (r) { return r['@rid']; }) : [];
      ctrl.eventsRids(rids);
      if (!rids.length) {
        ctrl.eventsRecords([]);
      }
    } catch (error) {
      console.error('Error loading events for component:', error);
      ctrl.eventsRids([]);
      ctrl.eventsRecords([]);
    } finally {
      ctrl.isLoading(false);
      m.redraw();
    }
  };

  ctrl.toggleSort = function () {
    ctrl.sortAscending(!ctrl.sortAscending());
  };

  ctrl.loadEvents();
  io.on('comment-event', ctrl.socketHandler);
  io.on('view-event', ctrl.socketHandler);
  io.on('command-event', ctrl.socketHandler);
};

eventsComponent.onremove = function () {
  if (this.socketHandler) {
    io.off('comment-event', this.socketHandler);
    io.off('view-event', this.socketHandler);
    io.off('command-event', this.socketHandler);
  }
};

function toTimestamp(value) {
  if (value === null || typeof value === 'undefined') return -Infinity;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    var numeric = Number(value);
    if (!Number.isNaN(numeric)) return numeric;
    var parsedDate = Date.parse(value);
    return Number.isNaN(parsedDate) ? -Infinity : parsedDate;
  }
  var parsed = Date.parse(value);
  return Number.isNaN(parsed) ? -Infinity : parsed;
}

function renderTable(records, sortAscending, onToggleSort) {
  var list = Array.isArray(records) ? records : [];
  var actualRecords = list.filter(function (record) { return record && record['@rid']; });
  var fillerRecords = list.filter(function (record) { return !record || !record['@rid']; });

  actualRecords.sort(function (a, b) {
    var tsA = toTimestamp(a && (a['@class'] === 'AlarmEvent' ? a.start : a.timestamp));
    var tsB = toTimestamp(b && (b['@class'] === 'AlarmEvent' ? b.start : b.timestamp));
    if (sortAscending) {
      if (tsA === -Infinity && tsB !== -Infinity) return 1;
      if (tsB === -Infinity && tsA !== -Infinity) return -1;
      return tsA - tsB;
    }
    if (tsA === -Infinity && tsB !== -Infinity) return 1;
    if (tsB === -Infinity && tsA !== -Infinity) return -1;
    return tsB - tsA;
  });

  var ordered = actualRecords.concat(fillerRecords);

  return m('div.overflow-hidden.mb3', [
    m('div.dragscroll-container', [
      m('div.dragscroll.pb3', { oncreate: dragscroll }, [
        m('table.f4.pb3.narrow.w-100.mr3', [
          m('tbody', [
            m('tr', [
              m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden' + (typeof onToggleSort === 'function' ? '.pointer' : ''), typeof onToggleSort === 'function' ? { onclick: onToggleSort } : {}, [
                'Timestamp',
                sortAscending ? m('i.ion-ios-arrow-up.ml2.blue') : m('i.ion-ios-arrow-down.ml2.blue')
              ]),
              m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Event Type'),
              m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'User'),
              m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Description'),
              m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Object'),
              m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Path'),
              m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', 'Value'),
              m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden.w-100', '')
            ]),
            ordered.map(function (record) {
              return renderEventRow(record);
            })
          ])
        ])
      ])
    ])
  ]);
}

eventsComponent.view = function (vnode) {
  var ctrl = this;
  var rids = Array.isArray(ctrl.eventsRids()) ? ctrl.eventsRids() : [];
  var records = Array.isArray(ctrl.eventsRecords()) ? ctrl.eventsRecords() : [];
  var isLoading = ctrl.isLoading();
  var sortAscending = ctrl.sortAscending();

  var total = rids.length;
  var expanded = ctrl.isExpanded();
  var canExpand = total > 0 || (isLoading && expanded);

  if (!canExpand && expanded) {
    ctrl.isExpanded(false);
    expanded = false;
  }

  var containerClass = `div.cf.mh3.bw1.mv2.b--grey${expanded ? '.pv3.bt.pl2.bl' : '.pa3.ba'}`;

  return m(containerClass, {
    style: {
      'border-left-style': expanded ? 'dotted' : 'solid'
    }
  }, [
    m('div.v-btm.flex.justify-between.items-center.flex-wrap.f2', {
      onclick: canExpand ? function () { ctrl.isExpanded(!ctrl.isExpanded()); } : undefined
    }, [
      m('div.flex.items-center.overflow-hidden', [
        m('div.white', 'Events')
      ]),
      m('div.flex.items-center.flex-wrap', [
        m('label.mr2.f5.moon-gray', 'Total:'),
        m('div.br2.nowrap.mr2', { style: { 'background-color': '#262626' } }, [
          m('label.f4.ph1.white', `${total || (isLoading ? '—' : 0)}`)
        ]),
        canExpand
          ? m(`i.icon.fr.ion-chevron-down.blue${expanded ? '.ion-close.f3.mr3' : '.ion-chevron-down'}`)
          : null
      ])
    ]),
    canExpand
      ? m(`div${expanded ? '' : '.dn'}`, [
        m('div.mt2', renderTable(records, sortAscending, ctrl.toggleSort)),
        m('div.mt3', [
          m(alarmsTablePagination, {
            data: [...rids],
            url: '/api/v1/events/paginated',
            recordsToShow: ctrl.eventsRecords,
            location: { '@rid': 'events-component' },
            numberOfColumns: ctrl.pageSize
          })
        ])
      ])
      : ''
  ]);
};

module.exports = eventsComponent;
